/**
 *      PACKAGE SEARCH PARAMETERS INSTRUCTIONS:
        Example url:
        /house-land/house-land-packages/?price=400000&price=700000&land=345&land=800&bath=2&builder=carlisle+homes&bed=3

        Parameters:
        Parameters can be used in any combination and any order. Invalid parameters are ignored

        price = 'Price Range'
        must be included twice, first is minimum, second is maximum.
        (will adjust to max/min bounds if paramaters are outside of them)

        land = 'Land Size'
        must be included twice, first is minimum, second is maximum.
        (will adjust to max/min bounds if paramaters are outside of them)

        bed = 'Bedrooms'
        single digit number, corresponds to that number +, e.g. 2 = 2+ Bedrooms
        (1 is all, or just leave this paramater out)
        must be a positive number

        bath = 'Bathrooms'
        single digit number, corresponds to that number +, e.g. 2 = 2+ Bathrooms
        (1 is all, or just leave this paramater out)
        must be a positive number

        builder = 'Builder'
        lowercase url-encoded builder name (any spaces replaced with "+" character)
        must match builder name from dropdown list
 */



import React from 'react';
import $ from 'jquery';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

let sources = require('../../config.json');
let priceFormat = wNumb({
    prefix: '$',
    decimals: 0,
    thousand: ','
});
let search = 0;

class PackageSearchBar extends React.Component {

    constructor(props) {
        super(props);
        this.searchfields_url = sources.searchfields;

        let p = this.props.search;
        let urlParams = { price: null, land: null, builder: null, bed: null, bath: null };


        if( 'price' in p && p.price.length === 2) {
            urlParams.price = { start: p.price[0], end: p.price[1] };
        }
        if( 'land' in p && p.land.length === 2) {
            urlParams.land = { start: p.land[0], end: p.land[1] };
        }
        if( 'bed' in p && parseInt(p.bed, 10) > 0) {
            urlParams.bed = p.bed;
        }
        if( 'bath' in p && parseInt(p.bath, 10) > 0) {
            urlParams.bath = p.bath;
        }
        if( 'builder' in p) {
            urlParams.builder = p.builder;
        }

        this.state = {
            onSearchClicked: props.onSearchClick,
            onResetClicked: props.onResetClick,
            urlParams: urlParams,
            priceBounds: {
                min: 460,
                max: 610
            },
            priceVal: {
                start: 400000,
                end: 600000
            },
            priceOpts: {
                step: 25000,
                margin: 50000
            },
            priceSlider: null,
            landBounds: {
                min: 400,
                max: 700
            },
            landVal: {
                start: 400,
                end: 700
            },
            landOpts: {
                step: 10,
                margin: 50
            },
            landSlider: null,
            builders: [],
            builderVal: '',
            bedVal: null,
            bathVal: null,
            accordion: true
        };

        this.landSliderUpdate = this.landSliderUpdate.bind(this);
        this.priceSliderUpdate = this.priceSliderUpdate.bind(this);
        this.onSearchClickEvent = this.onSearchClickEvent.bind(this);
        this.onSearchResetEvent = this.onSearchResetEvent.bind(this);
        this.initializeSliders = this.initializeSliders.bind(this);
        this.onInitializeEvent = this.onInitializeEvent.bind(this);
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        search = $('#searchBox').offset().top;
        window.addEventListener('scroll', this.handleScroll);

        let searchFields = $.ajax({url: this.searchfields_url,dataType:'json'});
        $.when(searchFields).done(function(search) {

            let newLand = { start: search.area.min, end: search.area.max };
            if(this.state.urlParams.land !== null) { newLand = this.state.urlParams.land; }

            let newPrice = { start: search.price.min, end: search.price.max };
            if(this.state.urlParams.price !== null) { newPrice = this.state.urlParams.price; }

            let newBed = '1';
            if(this.state.urlParams.bed !== null) { newBed = this.state.urlParams.bed; }
            let newBath = '1';
            if(this.state.urlParams.bath !== null) { newBath = this.state.urlParams.bath; }

            let newBuild = '';
            if(this.state.urlParams.builder !== null) {
                for(let i=0; i < search.builders.length; i++) {
                    if(this.state.urlParams.builder === search.builders[i].label.toLowerCase()) {
                        newBuild = search.builders[i].key;
                    }
                }
            }

            let newState = Object.assign(this.state, {
                priceBounds: search.price,
                priceVal: newPrice,
                landBounds: search.area,
                landVal: newLand,
                builders: search.builders,
                builderVal: newBuild,
                bedVal: newBed,
                bathVal: newBath,
            });
            this.setState(newState);
            this.initializeSliders();
            this.onInitializeEvent();
        }.bind(this));
    }

    handleScroll() {
        if ($(window).scrollTop() >= search){
            $('body').addClass('sticky-filter');

            $('.accordion__content').stop(true).slideUp('slow');
            $('.accordion__toggle').removeClass('open');

        } else if ($(window).scrollTop() < search) {
            $('body').removeClass('sticky-filter');

            $('.accordion__content').stop(true).slideDown('slow');
            $('.accordion__toggle').addClass('open');
        }
    }

    initializeSliders() {
        // Land Slider
        let landSlider = document.getElementById('slider--land');
        noUiSlider.create(landSlider, {
            connect: true,
            start: [ this.state.landVal.start, this.state.landVal.end ],
            margin: this.state.landOpts.margin,
            step: this.state.landOpts.step,
            range: this.state.landBounds,
            format: wNumb({
                decimals: 0
            })
        });

        // Display the slider value
        landSlider.noUiSlider.on('update', this.landSliderUpdate );

        // Price Slider
        let priceSlider = document.getElementById('slider--price');
        noUiSlider.create(priceSlider, {
            connect: true,
            start: [ this.state.priceVal.start, this.state.priceVal.end ],
            margin: this.state.priceOpts.margin,
            step: this.state.priceOpts.step,
            range: this.state.priceBounds,
            format: wNumb({
                decimals: 0
            })
        });

        // Display the slider value
        priceSlider.noUiSlider.on('update', this.priceSliderUpdate );

        // Store sliders into state
        let newState = Object.assign(this.state, {
            priceSlider: priceSlider,
            landSlider: landSlider
        });
        this.setState(newState);
    }

    landSliderUpdate(values) {
        let newState = Object.assign(this.state, {
            landVal: {
                start: values[0],
                end: values[1]
            }
        });
        this.setState(newState);
    }

    priceSliderUpdate(values) {
        let newState = Object.assign(this.state, {
            priceVal: {
                start: values[0],
                end: values[1]
            }
        });
        this.setState(newState);
    }

    onChangeHandler(type, event) {
        let update = {};
        switch (type) {
            case 'bath':
                update = { bathVal: $(event.target).attr('value') };
                break;
            case 'bed':
                update = { bedVal: $(event.target).attr('value') };
                break;
            case 'builder':
                update = { builderVal: $(event.target).val() };
                break;
            default:
        }
        let newState = Object.assign(this.state, update);
        this.setState(newState);
    }

    onSearchResetEvent() {
        if(this.state.onResetClicked !== null) {
            this.state.onResetClicked();
        }
        let newState = Object.assign(this.state, {
            priceVal: {
                start: this.state.priceBounds.min,
                end: this.state.priceBounds.max
            },
            landVal: {
                start: this.state.landBounds.min,
                end: this.state.landBounds.max
            },
            builderVal: '',
            bedVal: '1',
            bathVal: '1'
        });
        this.setState(newState);
        this.state.landSlider.noUiSlider.set([
            this.state.landVal.start,
            this.state.landVal.end,
        ]);
        this.state.priceSlider.noUiSlider.set([
            this.state.priceVal.start,
            this.state.priceVal.end,
        ]);
    }

    onSearchClickEvent() {
        if(this.state.onSearchClicked !== null) {
            let data = {
                price: this.state.priceVal,
                area: this.state.landVal,
                builder: this.state.builderVal,
                bath: this.state.bathVal,
                bed: this.state.bedVal
            };
            this.state.onSearchClicked(data);
        }
    }

    onInitializeEvent() {
        if(this.state.urlParams.price !== null || this.state.urlParams.land !== null || this.state.urlParams.builder !== null || this.state.urlParams.bed !== null || this.state.urlParams.bath !== null) {
            this.onSearchClickEvent();
        }
    }

    accordionToggle() {
        $('.accordion__content').stop(true).slideToggle('slow');
        $('.accordion__toggle').toggleClass('open');
    }

    render() {
        let priceStart = priceFormat.to(parseInt(this.state.priceVal.start, 10));
        let priceEnd = priceFormat.to(parseInt(this.state.priceVal.end, 10));
        return (
            <div className="filter land__filter"  id="searchBox">
                <div className="filter__header"> <div className="cf">
                        <div className="filter-toggle accordion__toggle open" onClick={this.accordionToggle}>
                            <img className="toggle__down" src='https://storage.googleapis.com/genfyansford.data.insiteinteractive.com.au/assets/images/icons/chevron-down--grey.svg' alt="" width="15px"/>
                            <img className="toggle__up" src='https://storage.googleapis.com/genfyansford.data.insiteinteractive.com.au/assets/images/icons/chevron-up--grey.svg' alt="" width="15px"/>
                            <span> Filter Results</span>
                        </div>

                        <div className="link__filter--reset" id="filter--reset" onClick={this.onSearchResetEvent} >Reset Filter</div>
                    </div>
                </div>
                    <div className="filter__content cf accordion__content ">
                        <div className="flex-grid--md cf"> <div className="filter__group left flex-col--md">
                                <div className="filter__group--col"> <div className="range__slider range__slider--price">
                                        <div className="cf"> <div className="filter__label slider__label"> $ Price </div>
                                            <div className="slider noUi-target noUi-ltr noUi-horizontal" id="slider--price">

                                            </div>

                                            <div className="slider__values">
                                                <span id="lower-value--price">{priceStart}</span> to
                                                <span id="upper-value--price"> {priceEnd}</span> </div>
                                        </div>
                                    </div>

                                    <div className="range__slider range__slider--price">
                                        <div className="cf"> <div className="filter__label slider__label"> Land Size </div>
                                            <div className="slider noUi-target noUi-ltr noUi-horizontal" id="slider--land">

                                            </div>

                                            <div className="slider__values">
                                                <span className="land-size" id="lower-value--land">{this.state.landVal.start}</span>m<sup>2</sup> to
                                                <span className="land-size" id="upper-value--land"> {this.state.landVal.end}</span>m<sup>2</sup>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="filter__group right flex-col--md">
                                <div className="filter__group--col beds-baths--filter">
                                    <div className="radio__group">
                                        <div className="filter__label radio__label"> Beds </div>
                                        <div className="radio__selection">
                                            <input id="bed1" name="house_bedrooms" type="radio" value="1" checked={this.state.bedVal === '1'} readOnly />
                                            <label className="radio__btn" value="1" onClick={(ev) => this.onChangeHandler('bed', ev) }>All</label>
                                            <input id="bed2" name="house_bedrooms" type="radio" value="2" checked={this.state.bedVal === '2'} readOnly />
                                            <label className="radio__btn" value="2" onClick={(ev) => this.onChangeHandler('bed', ev) }>2+</label>
                                            <input id="bed3" name="house_bedrooms" type="radio" value="3" checked={this.state.bedVal === '3'} readOnly />
                                            <label className="radio__btn" value="3" onClick={(ev) => this.onChangeHandler('bed', ev) }>3+</label>
                                            <input id="bed4" name="house_bedrooms" type="radio" value="4" checked={this.state.bedVal === '4'} readOnly />
                                            <label className="radio__btn" value="4" onClick={(ev) => this.onChangeHandler('bed', ev) }>4+</label>
                                            <input id="bed5" name="house_bedrooms" type="radio" value="5" checked={this.state.bedVal === '5'} readOnly />
                                            <label className="radio__btn" value="5" onClick={(ev) => this.onChangeHandler('bed', ev) }>5+</label>
                                        </div>
                                    </div>
                                    <div className="radio__group">
                                        <div className="filter__label radio__label"> Baths </div>
                                        <div className="radio__selection">
                                            <input id="baths1" name="house_bathrooms" type="radio" value="1" checked={this.state.bathVal === '1'} readOnly />
                                            <label className="radio__btn" value="1" onClick={(ev) => this.onChangeHandler('bath', ev) }>All</label>
                                            <input id="baths2" name="house_bathrooms" type="radio" value="2" checked={this.state.bathVal === '2'} readOnly />
                                            <label className="radio__btn" value="2" onClick={(ev) => this.onChangeHandler('bath', ev) }>2+</label>
                                            <input id="baths3" name="house_bathrooms" type="radio" value="3" checked={this.state.bathVal === '3'} readOnly />
                                            <label className="radio__btn" value="3" onClick={(ev) => this.onChangeHandler('bath', ev) }>3+</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="filter__group--col builder--filter">
                                    <div className="builder__selection cf">
                                        <label className="filter__label">Builder</label>
                                        <select className="form__control" name="builder_id" value={this.state.builderVal} onChange={(ev) => this.onChangeHandler('builder', ev) }>
                                            <option value=''> Select a Builder </option>
                                            {this.state.builders.map((b) => <option value={b.key} key={"builder-"+b.key}>{b.label}</option>)}
                                        </select>
                                    </div>

                                    <div className="btn__container">
                                        <div className="btn btn__action btn__filter-search searching" id="filter-search-btn" onClick={this.onSearchClickEvent}>
                                            Search<span className="searching-text">ing</span><span className="searching-dots">.</span><span className="searching-dots">.</span><span className="searching-dots">.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        );

    }
}

export default PackageSearchBar;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/elements/PackageSearchBar.js
 **/